import { render, staticRenderFns } from "./ModalPadres.vue?vue&type=template&id=6f975e92&"
import script from "./ModalPadres.vue?vue&type=script&lang=js&"
export * from "./ModalPadres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports